import * as Yup from 'yup';
import { validateAreaCode } from '../utils/validateAreaCode';

export const signUpSchema = Yup.object().shape({
    email: Yup.string()
        .email('Invalid email')
        .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email')
        .required('Required'),
    location: Yup.string().required('Required'),
    first_name: Yup.string()
        .required('Required')
        .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
    last_name: Yup.string()
        .required('Required')
        .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
    phone: Yup.string()
        .min(15, 'Invalid phone number')
        .required('Required')
        .test('no-identical-area-code', 'Invalid phone number', validateAreaCode),
});
